import { fetchJson } from './client';

export const project = {
  getAll: () => fetchJson<any[]>('/projects'),
  get: (id: string) => fetchJson<any>(`/projects/${id}`),
  create: (input: { name: string; clientId?: string; siteId?: string; address?: string }) =>
    fetchJson<any>('/projects', { method: 'POST', body: JSON.stringify(input) }),
  update: (input: { id: string; updates: Record<string, unknown> }) =>
    fetchJson<any>(`/projects/${input.id}`, { method: 'PATCH', body: JSON.stringify(input.updates) }),
  delete: (id: string) => fetchJson<any>(`/projects/${id}`, { method: 'DELETE' }),
};
